import { PoprPriority } from '../popr-priority.enum';

/**
 * Everything necessary to create toast
 */
export class PoprToastPackage {
  constructor(public config: {
    button?: { label: string | undefined; url: string | undefined };
    priority: PoprPriority;
    title?: string | undefined;
  }) {}
}

